import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { AuthLayout } from "@/pages/Login";
import { useLanguage } from "@/context/LanguageContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch { /* generic response either way */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <AuthLayout>
      <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm sm:p-8" data-testid="forgot-card">
        <Link to="/login" className="mb-4 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900" data-testid="forgot-back-link">
          <ArrowLeft className="h-4 w-4" /> {t("back_to_login")}
        </Link>
        <h1 className="font-display text-2xl font-bold text-slate-900">{t("forgot_title")}</h1>
        <p className="mt-1 text-sm text-slate-500">{t("forgot_subtitle")}</p>

        {!sent ? (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">{t("email")}</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-1.5 min-h-[48px]" autoComplete="email" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="min-h-[48px] w-full rounded-xl font-semibold">
              {loading ? t("loading") : t("send_reset")}
            </Button>
          </form>
        ) : (
          <div className="mt-6" data-testid="forgot-success">
            <div className="flex items-start gap-2.5 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
              <Mail className="mt-0.5 h-4 w-4 flex-shrink-0" />
              <div><span className="font-semibold">{t("reset_email_sent")} </span>{t("reset_email_note")}</div>
            </div>
            <Link to="/login" className="mt-5 block">
              <Button className="min-h-[48px] w-full rounded-xl font-semibold" data-testid="forgot-done-btn">{t("back_to_login")}</Button>
            </Link>
          </div>
        )}
      </div>
    </AuthLayout>
  );
}
